var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-page"},[_c('block-header-standard',{attrs:{"title":_vm.t('notifications')}}),_c('div',{staticClass:"list-container-outer"},[_c('div',{staticClass:"list-wrapper"},[_c('notifications-component')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }